import { BackgroundColor } from '@ampcore/ampcom-contracts'

export const complexHeroBackgroundColors = [
  BackgroundColor.MIDNIGHT_BLUE,
  BackgroundColor.LIGHT_BLUE,
  BackgroundColor.PURPLE,
  BackgroundColor.BERRY,
  BackgroundColor.MINT,
  BackgroundColor.DARK_MINT,
  BackgroundColor.ORANGE,
  BackgroundColor.DARK_GREY,
  BackgroundColor.WHITE,
  BackgroundColor.NONE
] as const

export type ComplexHeroBackgroundColor =
  (typeof complexHeroBackgroundColors)[number]
